export default __webpack_public_path__ + "static/media/hm-l22-img.b9f9923a.webp";